<div #content class='horizontal-container justify-content-between d-flex align-items-center flex-nowrap'>
  <ng-content></ng-content>
</div>
